<template>
  <div v-if="info !== null" class="column q-gutter-y-md q-pt-xs">
    <div v-if="info.title !== undefined" style="line-height: 1.6rem" class="q-pb-md text-grey-9 text-h6 text-weight-bold">
      {{ info.title }}
      <div v-if="info.caption" class="text-grey-7 text-subtitle2 q-pt-sm">
        <DDynamicText v-if="info.caption.dynamic" :dynamic="info.caption.dynamic" :parentMetas="parentMetas" />
        <span v-else>{{ info.caption }}</span>
      </div>
    </div>

    <div v-for="(section, index) in info.sections" :key="uniqueId(index)" aria-label="info-section-item">
      <div v-if="section.subtitle !== undefined" class="row" @click="showSection(index)" aria-label="info-section-item-btn">
        <div class="text-subtitle1 text-weight-bold cursor-pointer text-secondary"
          style="max-width: calc(100% - 35px); overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;"
          v-html="section.subtitle"></div>
        <q-btn round dense flat size="small" color="secondary"
          :icon="listShow.includes(index) ? 'expand_less' : 'expand_more'" class="q-ml-auto" />
      </div>
      <q-separator :class="listShow.includes(index) ? 'q-mb-md' : ''" />
      <div v-show="listShow.includes(index)" :key="uniqueId(index)" class="list">
        <div v-if="section.video !== undefined">
          <q-video :src="section.video.src" style="height: 200px" />
        </div>
        <div class="q-pr-sm" v-if="section.html !== undefined" v-html="section.html"></div>
        <ul v-if="section.bullets !== undefined" style="
            margin-left: 30px;
            margin-top: 10px;
            margin-bottom: 0;
            padding: 0;
          ">
          <li v-for="(bullet, index) in section.bullets" :key="uniqueId(index)" v-html="bullet"></li>
        </ul>
        <q-list v-if="section.list !== undefined || section.listDynamic" class="q-mt-sm q-pr-sm" separator>
          <template v-if="section.list">
            <q-item class="q-px-none" v-for="(listItem, index) in section.list" :key="uniqueId(index)">
              <q-item-section v-html="listItem.label"></q-item-section>
              <q-item-section>
                <q-item-label class="text-right" v-html="listItem.value"></q-item-label>
              </q-item-section>
            </q-item>
          </template>
          <template v-if="section.listDynamic">
            <q-item class="q-px-none" v-for="(item, index) in getListDynamicValues(section.listDynamic)" :key="index">
              <q-item-section v-html="item.label"></q-item-section>
              <q-item-section :key="index">
                <q-item-label class="text-right">
                  {{ item.value }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </template>
          <q-separator />
        </q-list>
        <div class="q-pr-sm" v-if="section.vList !== undefined || section.vListDynamic">
          <template v-if="section.vList">
            <div class="q-mt-md q-pt-sm" v-for="(vListItem, index) in section.vList" :key="uniqueId(index)">
              <div class="text-subtitle2 q-mb-sm text-grey-9 text-weight-bold" v-html="vListItem.label">
              </div>
              <div v-html="vListItem.value"></div>
            </div>
          </template>
          <template v-if="section.vListDynamic">
            <div class="q-mt-md q-pt-sm" v-for="(item, index) in getVListDynamicValues(section.vListDynamic)" :key="index">
              <div class="text-subtitle2 q-mb-sm text-grey-9 text-weight-bold" v-html="item.label">
              </div>
              <div v-html="item.value"></div>
            </div>
          </template>
        </div>
        <div v-if="section.table !== undefined">
          <q-markup-table class="text-grey-9" flat wrap-cells>
            <thead v-if="section.table.head !== undefined">
              <tr>
                <th v-for="(head, index) in section.table.head" :key="uniqueId(index)"
                  :class="head.align ? head.align : 'text-left'">
                  {{ head.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(body, index) in section.table.body" :key="uniqueId(index)">
                <td v-for="(cell, index) in body" :key="uniqueId(index)" :class="cell.align ? cell.align : 'text-left'"
                  v-html="cell.text"></td>
              </tr>
            </tbody>
          </q-markup-table>
        </div>
      </div>
      <div class="q-pb-sm"></div>
    </div>
  </div>
</template>
<script>
import { uid } from "quasar";
import DDynamicText from "../DCard/components/DDynamicText/DDynamicText.vue";

export default {
  name: "DCardInfo",
  components: {
    DDynamicText
  },
  props: {
    info: {
      default: null
    },
    // determine if the user is viewing a sequence of cards
    sequence: {
      default: false
    },
    parentMetas: {
      type: Object,
      require: false,
      default: () => {}
    },
    reset: {
      type: Boolean,
      require: false,
      default: () => false
    }
  },
  data() {
    return {
      listShow: []
    };
  },
  mounted() {
    this.listShow = [];
    // show all sections if user is in a sequencie of cards
    if (this.sequence) {
      this.showAllSection();
    } else {
      if (
        this.info !== null &&
        this.info?.sections &&
        this.info.sections.length > 0
      ) {
        //this.showSection(0);
        this.showAllSection(); // Requested by NCL agents
      }
    }
  },
  methods: {
    uniqueId(index) {
      return uid() + index;
    },
    showSection(index) {
      if (this.listShow.includes(index)) {
        this.listShow = this.listShow.filter((item) => item != index);
      } else {
        this.listShow.push(index);
      }
    },
    showAllSection() {
      this.info?.sections?.map((item, index) => this.listShow.push(index));
    },
    getListDynamicValues(dynamic) {
      if (dynamic.validation.metas) {
        return this.filterValuesByMetas(dynamic)
      }
      return []
    },
    getVListDynamicValues(dynamic) {
      if (dynamic.validation.metas) {
        return this.filterValuesByMetas(dynamic)
      }
      return []
    },
    filterValuesByMetas(dynamic) {
      if (!this.parentMetas) {
        return [];
      }
      const metaName = dynamic.validation.metas.meta ?? "parentId";
      if (!this.parentMetas[metaName]) {
        return [];
      }
      const match = dynamic.items.find(i => {
        switch (dynamic.validation.metas.logic) {
          case "!=":
            return i.ref.toLowerCase() !== this.parentMetas[metaName].toLowerCase();
          case ">":
            return i.ref.toLowerCase() > this.parentMetas[metaName].toLowerCase();
          case ">=":
            return i.ref.toLowerCase() >= this.parentMetas[metaName].toLowerCase();
          case "<":
            return i.ref.toLowerCase() < this.parentMetas[metaName].toLowerCase();
          case "<=":
            return i.ref.toLowerCase() <= this.parentMetas[metaName].toLowerCase();
          case "includes":
            if (this.parentMetas[metaName] instanceof Array) {
              return this.parentMetas[metaName].map(t => t.toLowerCase()).includes(i.ref.toLowerCase())
            }
            return this.parentMetas[metaName].toLowerCase().includes(i.ref.toLowerCase())
          default:
            return i.ref.toLowerCase() === this.parentMetas[metaName].toLowerCase();
        }
      })
      return match?.values ?? []
    }
  },
  watch: {
    reset() {
      this.listShow = []
      this.showAllSection()
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
